<script>
    import {getStyleValue, imageUrl} from "../../Common/tools";
    import TextEditor from "../../Common/TextEditor.svelte";
    import {External} from "../../external";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }
</script>
<tr>
    <th style="background-color: {data.style.color}">
        <table class="row" cellspacing="0" cellpadding="0" align="center" style="width: {data.style.width};">
            <tbody>
            <tr>
                <th class="column mobile-12"
                    style="font-weight: 400; background-repeat: no-repeat; background-position: center; background-size: cover;"
                    width="{getStyleValue(globalStyle.width, 600)}" bgcolor=""
                    background="{imageUrl(data, External.resources + '/images/marketing/placeholders/700x500.png')}">
                    <table>
                        <tbody >
                            <tr>
                                <th class="column mobile-12"
                                    width="{getStyleValue(globalStyle.width, 600)*0.15}">
                                </th>
                                <th class="column mobile-12"
                                    style="font-weight: 400; background-repeat: no-repeat; background-position: center; background-size: cover;"
                                    width="{getStyleValue(globalStyle.width, 600)*0.7}">
                                    <div class="spacer" style="font-size: {data.style.paddingTop}; line-height: {data.style.paddingTop};">&nbsp;</div>
                                    <center>
                                        <a href="" class="hover-shrink"
                                           style="display: block; transition: all 0.3s ease-in-out 0s; pointer-events: none;">
                                            <img src="{External.resources + '/images/marketing/button-play-filled.png'}" alt="Play"
                                                 style="border: 0; margin: 0 auto; width: 100%; max-width: 66px;" width="66">
                                        </a>
                                    </center>
                                    <TextEditor bind:data={data.content} meta={meta} onChange={change} emailEditor={true} />
                                    <div class="spacer" style="font-size: {data.style.paddingBottom}; line-height: {data.style.paddingBottom};">&nbsp;</div>
                                </th>
                                <th class="column mobile-12"
                                    width="{getStyleValue(globalStyle.width, 600)*0.15}">
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </th>
            </tr>
            </tbody>
        </table>
    </th>
</tr>